import { CatalogItemType } from '@common/model/catalog/item/type';
import { Platform } from '@common/model/platform';
import { adminCatalogItemApi } from 'src/entities/catalog/item';

const vacancyModerationBadgeCountQuery = {
  type: CatalogItemType.Vacancy,
  isPublished: false,
  registrationPlatform: { not: Platform.ApiServer },
  pagination: 1,
  page: 1,
} as const;

export const useVacancyModerationBadgeCountQuery = () => {
  const { data, isSuccess } = adminCatalogItemApi.endpoints.getList.useQuery(vacancyModerationBadgeCountQuery);

  return {
    count: data?.totalCount ?? 0,
    isReady: isSuccess,
  };
};

export const useVacancyModerationBadgeCount = (): number => {
  return useVacancyModerationBadgeCountQuery().count;
};
